import { useStore } from 'vuex';
import { useProductPickerStore } from '../composable/useProductPickerStore';

import MESSAGE_LIST from '../constants/messageConstants';

export const usePopupMessage = () => {
  const store = useStore();
  const { setIsDisplayMessage } = useProductPickerStore();

  //computed
  const key = computed(() => {
    return 'MANUALLY_SELECT';
  });

  const pageId = computed(() => {
    return store.state.app.pageInfo.page.id;
  });

  const displayedMessage = computed(() => {
    return MESSAGE_LIST[key.value as keyof typeof MESSAGE_LIST];
  });

  const isDisplayMessage = computed(() => {
    const items = localStorage.getItem(key.value);
    setIsDisplayMessage(!items?.includes(pageId.value));
    return !items?.includes(pageId.value);
  });

  //methods
  const onGotMessage = async () => {
    const items = localStorage.getItem(key.value);
    const list = items ? JSON.parse(items) : [];
    if (!list.includes(pageId.value)) {
      setIsDisplayMessage(false);
      list.push(pageId.value);
    }
    localStorage.setItem(key.value, JSON.stringify(list));
  };

  return { isDisplayMessage, displayedMessage, onGotMessage };
};
